/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GoogleProtobufValueFromJSON, GoogleProtobufValueToJSON, } from './';
export function GoogleProtobufListValueFromJSON(json) {
    return GoogleProtobufListValueFromJSONTyped(json, false);
}
export function GoogleProtobufListValueFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'values': !exists(json, 'values') ? undefined : (json['values'].map(GoogleProtobufValueFromJSON)),
    };
}
export function GoogleProtobufListValueToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'values': value.values === undefined ? undefined : (value.values.map(GoogleProtobufValueToJSON)),
    };
}
//# sourceMappingURL=GoogleProtobufListValue.js.map